import * as yup from 'yup'

const UserValidator = yup.object().shape({
  firstName: yup.string().required().max(64),
  lastName: yup.string().required().max(64),
})

export default UserValidator
